<template>
    <div>
        <draggable v-model="items" handle=".handle" @input="emit">
            <tags-item
                v-for="(item, index) in items"
                :key="item.tempId"
                v-model="items[index]"
                v-bind="{
                    showsDivider: index < items.length - 1,
                }"
                v-on="{
                    pull,
                }"
                @input="emit"
            />
        </draggable>
        <v-divider />
        <v-row no-gutters class="justify-end">
            <v-divider vertical />
            <v-btn icon tile width="40" min-height="40" color="primary" @click="push">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-row>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import { initCommonMetatag_Tag, COMMON_METATAG_TAG_TYPES } from "@/store/metatags";

import TagsItem from "./list/tags-item.vue";

export default {
    components: {
        Draggable,
        TagsItem,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        items: [],
    }),
    methods: {
        sync() {
            this.items = [...this.value].map(initCommonMetatag_Tag);
        },
        emit() {
            this.$emit("input", this.items);
        },
        pull(item) {
            let index = this.items.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.items.splice(index, 1);
            this.emit();
        },
        push() {
            this.items.push(
                initCommonMetatag_Tag({
                    type: COMMON_METATAG_TAG_TYPES.meta.value,
                })
            );
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
